// extracted by mini-css-extract-plugin
module.exports = {"container":"BorderedTag_container__1FVBG","type-danger":"BorderedTag_type-danger__oubbU"};